import type { FunctionComponent, SVGProps } from 'react';
import { RecentlyUsedBadge } from './RecentlyUsedBadge';

export function SSOProviderButton({
   appId,
   Logo,
   logoViewBox = '0 0 24 24',
   label,
   onClick,
   disabled,
   recentlyUsed,
}: {
   appId: 'googleLogin' | 'appleLogin' | 'facebookLogin';
   Logo: FunctionComponent<SVGProps<SVGSVGElement>>;
   logoViewBox?: string;
   label: string;
   onClick?: () => void;
   disabled?: boolean;
   recentlyUsed?: boolean;
}) {
   // The mobile app finds Google and Facebook by id and Apple by data-mobile-appid.
   return (
      <div
         id={appId}
         data-mobile-appid={appId}
         onClick={onClick}
         aria-disabled={disabled}
         className={disabled ? 'pointer-events-none' : 'cursor-pointer'}
      >
         <button type="button" className="button-sso-provider z-1 w-full gap-2" disabled={disabled}>
            {/* Our SVG loader strips viewBox, so the drawing only scales to its box with it passed back. */}
            <Logo className="size-6" viewBox={logoViewBox} />
            <span className="min-w-0 truncate">{label}</span>
         </button>
         {recentlyUsed && <RecentlyUsedBadge />}
      </div>
   );
}
